type Callback<D, E = unknown> = (cb: (err: E, data: D) => unknown) => unknown;
/**
 * Wraps a method with `(err, data) => `-callback interface in a promise.
 * @param fn The function to promisify
 * @param self The object to call the function on, i.e. the instance of the method to be called
 * @returns {Promise<any>}
 */
export const promisify = <Arg extends readonly unknown[], Data, Err, Ctx>(fn: (...args: [...Arg, Callback<Data, Err>]) => void, self: Ctx|null = null) =>
    (...args: Arg) =>
        new Promise<Data>((res, rej) => {
            fn.apply(self, [ ...args, (err, data) => err ? rej(err) : res(data) ]);
        });

/**
 * Get the current location without query string or hash
 */
export const getLocation = (): string => `${location.protocol}//${location.host}${location.pathname}`;

/**
 * Checks the user-agent string for being an IE browser
 * https://stackoverflow.com/a/26358856
 */
export const isOldIE = (): boolean => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
        const ver = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)));
        return !isNaN(ver);
    }
    return false;
};
